var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex h-full items-end pr-7 space-x-7"},_vm._l((_vm.userMenuItems),function(item,i){return _c('div',{key:i},[_c('NavItem',{attrs:{"title":item.title,"icon":item.icon,"path":item.path,"disabled":item.disabled}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }